import { Flex, Alert } from "antd";
import { Outlet } from "react-router";
import "./olympiad.less";
import { userStore } from "../../store/store";

export default function OlympiadPage() {
  const currentDate = new Date();
  const {user, setUser} = userStore();
  const targetDate = new Date(2025, 10, 24);

  if (!user.roles.includes("OLYMPIAD_ADMIN") && currentDate < targetDate) {
    return (
      <Flex className="olympiad" vertical align="center" justify="center" style={{ minHeight: "60vh" }}>
        <Alert
          message="Запись на олимпиады"
          description="Запись на олимпиады будет доступна с 24.11.2025"
          type="info"
          showIcon
        />
      </Flex>
    );
  }

  return (
    <Flex className="olympiad" vertical gap={16} align="center">
      <Outlet />
    </Flex>
  );
}